let observerStarted = false;

function createButton() {

    const tracking = document.querySelector(
        ".OrderTracking-TrackingInformation__TrackingNumber .OrderTracking-Text"
    );

    if (!tracking) return;

    if (document.getElementById("checkCourierBtn")) return;

    const trackingNumber = tracking.textContent.trim();

    const btn = document.createElement("button");

    btn.id = "checkCourierBtn";
    btn.innerText = "Check Courier Status";

    btn.style.marginTop = "15px";
    btn.style.width = "100%";
    btn.style.padding = "14px";
    btn.style.background = "#000";
    btn.style.color = "#fff";
    btn.style.border = "0";
    btn.style.borderRadius = "8px";
    btn.style.cursor = "pointer";
    btn.style.fontSize = "16px";

    btn.onclick = function () {

        let url = "";

        if (trackingNumber.length === 12) {

            url = "https://www.tcsexpress.com/track/" + trackingNumber;

        } else if (trackingNumber.length === 15) {

            url = "https://www.mulphilog.com/tracking/" + trackingNumber;

        } else {

            alert("Unsupported Tracking Number");
            return;

        }

        // Mobile aur Desktop dono ke liye
        window.location.href = url;

    };

    tracking.closest(".OrderTracking-TrackingInformation")
        .appendChild(btn);
}

function startObserver() {

    if (observerStarted) return;

    observerStarted = true;

    const observer = new MutationObserver(createButton);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

}

document.addEventListener("DOMContentLoaded", startObserver);